import React from 'react';
import { FiInstagram, FiMail } from 'react-icons/fi';
import styles from './Footer.module.css';
import logo from '../../assets/logo.webp';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Work', href: '#portfolio' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const handleNav = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.top}>
        <div className={styles.brand}>
          <img src={logo} alt="AussieRooArt" className={styles.logo} />
          <p className={styles.tagline}>
            Art that lives on every surface — murals, canvas, textile, and beyond.
          </p>
          <div className={styles.socials}>
            <a
              href="https://www.instagram.com/aussierooart"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className={styles.social}
            >
              <FiInstagram />
            </a>
            <a
              href="mailto:uredibilge@gmail.com"
              aria-label="Email"
              className={styles.social}
            >
              <FiMail />
            </a>
          </div>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>Navigation</h4>
          <ul className={styles.colLinks}>
            {navLinks.map(l => (
              <li key={l.label}>
                <a href={l.href} onClick={e => handleNav(e, l.href)}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>Services</h4>
          <ul className={styles.colLinks}>
            <li><a href="#services" onClick={e => handleNav(e, '#services')}>Custom Murals</a></li>
            <li><a href="#services" onClick={e => handleNav(e, '#services')}>Canvas & Studio Art</a></li>
            <li><a href="#services" onClick={e => handleNav(e, '#services')}>Surface & Textile Design</a></li>
            <li><a href="#services" onClick={e => handleNav(e, '#services')}>Commissioned Artwork</a></li>
          </ul>
        </div>

        <div className={styles.col}>
          <h4 className={styles.colTitle}>Book a Project</h4>
          <ul className={styles.colLinks}>
            <li>
              <a href="https://bookanartist.co/artist/artist-for-hire/13184" target="_blank" rel="noopener noreferrer">
                Book an Artist
              </a>
            </li>
            <li><a href="mailto:uredibilge@gmail.com">uredibilge@gmail.com</a></li>
            <li><a href="tel:+17787888294">+1 778 788 8294</a></li>
          </ul>
          <a
            href="https://bookanartist.co/artist/artist-for-hire/13184"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.bookBtn}
          >
            Book Now
          </a>
        </div>
      </div>

      <div className={styles.bottom}>
        <p className={styles.copy}>
          © {new Date().getFullYear()} AussieRooArt · Bilge. All rights reserved.
        </p>
        <p className={styles.location}>Vancouver, BC, Canada</p>
      </div>
    </footer>
  );
}
